<mat-dialog-content class="rating-form-dialog">
  <header class="rating-form-dialog__header">
    <div>
      <span class="rating-form-dialog__eyebrow">
        <i class="inm-icon-star" aria-hidden="true"></i>
        {{ 'rating_modal.eyebrow' | translate }}
      </span>
      <h2>{{ (isEditing() ? 'rating_modal.edit_title' : 'rating_modal.title') | translate }}</h2>
      <p>{{ 'rating_modal.subtitle' | translate }}</p>
    </div>
    <button
      type="button"
      class="rating-form-dialog__close"
      [attr.aria-label]="'cerrar' | translate"
      (click)="dialogRef.close()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </header>

  <section class="rating-form-dialog__rating" aria-labelledby="rating-question">
    <h3 id="rating-question">{{ 'rating_modal.question' | translate }}</h3>
    <app-rating
      [qualification]="qualification()"
      [showRatingNumber]="false"
      [marginAuto]="true"
      size="42px"
      (qualificationChange)="setQualification($event)"
    />
    @if (qualification()) {
      <p class="rating-form-dialog__selected">
        {{ qualification() }} / 5 · {{ 'rating_modal.selected' | translate }}
      </p>
    } @else {
      <p class="rating-form-dialog__hint">{{ 'rating_modal.required' | translate }}</p>
    }
  </section>

  <label class="rating-form-dialog__field" for="rating-comment">
    <span>
      {{ 'rating_modal.comment_label' | translate }}
      <small>{{ 'rating_modal.optional' | translate }}</small>
    </span>
    <textarea
      id="rating-comment"
      rows="4"
      maxlength="500"
      [ngModel]="comment()"
      (ngModelChange)="setComment($event)"
      [placeholder]="'rating_modal.comment_placeholder' | translate"
    ></textarea>
    <small class="rating-form-dialog__counter">{{ comment().length }}/500</small>
  </label>
</mat-dialog-content>

<mat-dialog-actions class="rating-form-dialog__actions">
  <button type="button" class="rating-form-dialog__cancel" (click)="dialogRef.close()">
    {{ 'cancelar' | translate }}
  </button>
  <button
    type="button"
    class="rating-form-dialog__submit"
    [disabled]="qualification() < 1"
    (click)="submit()"
  >
    <i class="inm-icon-star" aria-hidden="true"></i>
    {{ (isEditing() ? 'rating_modal.update' : 'rating_modal.submit') | translate }}
  </button>
</mat-dialog-actions>
